import { createAction } from '@utils/helpers';
import { SEND_RECOMMEND_TO_A_FRIEND } from './types';

export const sendRecommendToAFriend = createAction(SEND_RECOMMEND_TO_A_FRIEND);
